@if (date) {
  {{ date | date:format }}
}
<ng-content></ng-content>
